<script setup lang="ts">
defineProps<{
  modelValue?: string | null;
}>();

const emit = defineEmits<{
  'update:modelValue': [value: string];
}>();

function handleInput(event: Event): void {
  emit('update:modelValue', (event.target as HTMLTextAreaElement).value);
}
</script>

<template>
  <textarea
    :value="modelValue ?? ''"
    @input="handleInput"
    rows="3"
    class="description-textarea"
    placeholder="Add description..."
  />
</template>

<style scoped>
.description-textarea {
  width: 100%;
  padding: 0.75rem 1rem;
  border-radius: 0.75rem;
  border: 1px solid var(--p-surface-200);
  background: white;
  color: var(--p-surface-700);
  font-size: 0.875rem;
  line-height: 1.6;
  min-height: 80px;
  outline: none;
  transition: all 0.15s;
  resize: vertical;
  font-family: inherit;
}
:root[class*='app-dark'] .description-textarea {
  border-color: var(--p-surface-700);
  background: var(--p-surface-800);
  color: var(--p-surface-300);
}
.description-textarea:hover {
  border-color: var(--p-primary-300);
}
:root[class*='app-dark'] .description-textarea:hover {
  border-color: var(--p-primary-600);
}
.description-textarea:focus {
  border-color: var(--p-primary-400);
  box-shadow: 0 0 0 2px color-mix(in srgb, var(--p-primary-500) 10%, transparent);
}
.description-textarea::placeholder {
  color: var(--p-surface-400);
}
</style>
